export default __webpack_public_path__ + "static/scrollb-3d071e4a4a1687b62572bcde1b608efe.png";